import clsx from 'clsx';
import { fromEmpty } from 'maybeasy';
import { observer } from 'mobx-react';
import { emptyFragment } from '../../../../../../EmptyFragment';
import { T } from '../../../../../../Translations';
import VideoIcon from '../../../../../Cutesies/VideoIcon';
import ModalStore from '../../../../../Modal/Store';
import { ProductLicenseResource } from '../../../../Types';
import LearningCollectionEditStore from '../../../Edit/Store';

interface Props {
  store: LearningCollectionEditStore;
  videoProjectFeedbackModalStore: ModalStore;
}

function ProjectFeedback({ store, videoProjectFeedbackModalStore }: Props) {
  return store.selectedProductLicense
    .andThen((productLicenseResource: ProductLicenseResource) =>
      fromEmpty(productLicenseResource.payload.extensionIds),
    )
    .map(() => (
      <div
        className={clsx(
          'rounded-md border border-solid border-gray-200 bg-white px-5 py-4',
          'flex items-center',
        )}
      >
        <VideoIcon />
        <p className="ml-3 text-sm">
          <T
            kind="Participants receive <span>Project Feedback</span> from a coach"
            span={(translated) => (
              <span
                className="cursor-pointer font-semibold underline"
                onClick={videoProjectFeedbackModalStore.open}
              >
                {translated}
              </span>
            )}
          />
        </p>
      </div>
    ))
    .getOrElse(emptyFragment);
}

export default observer(ProjectFeedback);
